<template>
  <footer class="footer text-center">
    <p class="text__footer">
      <strong>原案：道尾秀介 監督・編集：戸田彬弘</strong>
      脚本：守口悠介 製作統括：井川楊枝 プロデューサー：前 信介 企画協力：狩野善則 音楽：茂野雅道 撮影：根岸憲一 <br class="is-hidden-tablet">録音：鈴木健太郎
      <br>MA：吉方淳二 音響効果：國分 玲 助監督：平波 亘 <br class="is-hidden-tablet">制作担当：森田博之 スチール：北島元朗 <br class="is-hidden-tablet">主題歌：「光」DEN（谷本賢一郎×道尾秀介）
      <br>制作プロダクション：グラスゴー15 <br class="is-hidden-tablet">企画・製作：一般社団法人茨城南青年会議所 <br class="is-hidden-tablet">配給・宣伝：アルゴ・ピクチャーズ
      <br>製作：MARCOT／GLASGOW15／チーズfilm／<br class="is-hidden-tablet">ムービー・アクト・プロジェクト <br class="is-hidden-tablet">©️2018 映画「名前」製作委員会 <br class="is-hidden-tablet">2018／日本／カラー／5.1ch／114分
    </p>
      <!-- <p class="credits">©️2018 映画「名前」製作委員会</p> -->
  </footer>
</template>

<script>
export default {
  name: 'hero',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue